"use strict";
exports.__esModule = true;
var modules_1 = require("./modules");
function getDeviceTransactionConfig(input) {
    var transaction = input.transaction, estimatedFees = input.status.estimatedFees;
    var m = modules_1.modes[transaction.mode];
    var fields = [];
    if (m && m.fillDeviceTransactionConfig) {
        m.fillDeviceTransactionConfig(input, fields);
    }
    if (estimatedFees && !estimatedFees.isZero()) {
        fields.push({
            type: "fees",
            label: "Max fees"
        });
    }
    return fields;
}
exports["default"] = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map